import { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'
import { HeaderSelectTemplate } from './HeaderSelectTemplate'
import ModalEmptySource from './ModalEmptySource'
import ModalIgnoreChanges from './ModalIgnoreChanges'
import ModalLimitDataContent from './ModalLimitDataContent'

import { checkSourceContentCallback } from 'Pages/Campaign/recoil/callbacks/carouselCallbacks'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { templatePreviewState } from 'Pages/Campaign/recoil/state/templates'

const StyledFrameContainer = styled.div`
  width: 100%;
  height: calc(100vh - 65px);
  z-index: 0;

  #iFrame {
    width: 100%;
    height: 100%;
  }
`

export const SelectTemplate = () => {
  const { IdSource } = useRecoilValue(campaignState)
  const { body } = useRecoilValue(templatePreviewState)
  const checkSourceContent = useRecoilCallback(checkSourceContentCallback, [])

  useEffect(() => {
    if (IdSource) {
      checkSourceContent()
    }
  }, [IdSource])

  useEffect(() => {
    if (document.getElementById('iFrame')) {
      document.getElementById('iFrame').contentWindow.document.open()
      document.getElementById('iFrame').contentWindow.document.close()
      document.getElementById('iFrame').contentWindow.document.write(body)
    }
  }, [body])

  return (
    <>
      <ModalIgnoreChanges />
      <ModalLimitDataContent />
      <ModalEmptySource />
      <HeaderSelectTemplate />
      <StyledFrameContainer>
        <iframe
          id='iFrame'
          frameBorder='0'
          scrolling='yes'
          data-hj-allow-iframe='true'
        />
      </StyledFrameContainer>
    </>
  )
}
